<template>
  <div class="loginByQRCode">
    <img
      :src="imagePath.loginByPwdOrCode"
      class="switchBtn cp"
      @click="handleSwitchLogin"
    />
    <img class="luojigouHead" :src="imagePath.luojigouHead" />
    <div class="title">家校共育</div>
    <div class="mark">让儿童能力成长看得见</div>
    <div class="container">
      <div class="QRCode" ref="qrCodeUrl"></div>
      <div v-if="isExpired" class="container-mask" @click="$emit('getQR')">
        <span>二维码已过期</span>
        <span>请点击刷新</span>
      </div>
    </div>
    <div class="tips">请用手机-逻辑狗·家园共育APP园所端-扫码登录</div>
  </div>
</template>

<script>
import imagePath from "@/utils/imagePath";
import QRCode from "qrcodejs2";

export default {
  name: "LoginByQRCode", // 二维码登录
  props: {
    // 登录二维码唯一id
    QrCodeUrl: {
      type: String,
      default: ""
    },
    isExpired: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      imagePath
    };
  },
  created() {
    this.$emit("getQR");
  },
  mounted() {
    window.addEventListener("resize", this.handleSetQrCodeWidth);
  },
  watch: {
    QrCodeUrl(val) {
      if (val) {
        this.creatQrCode(val);
      }
    }
  },
  methods: {
    // 给二维码做适配，根据当前视口宽度
    handleSetQrCodeWidth() {
      const width = window.innerWidth;
      const eleWidth = `${(width * 280) / 1920}px`;
      this.$refs.qrCodeUrl.childNodes[1].style.width = eleWidth;
      this.$refs.qrCodeUrl.childNodes[1].style.height = eleWidth;
    },
    // 获取二维码
    creatQrCode(QrCodeUrl) {
      console.log(QrCodeUrl, "QrCodeUrl");
      //清除之前的二维码
      this.$refs.qrCodeUrl.innerHTML = "";
      new QRCode(this.$refs.qrCodeUrl, {
        text: QrCodeUrl, // 需要转换为二维码的内容
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H
      });
      this.handleSetQrCodeWidth();
    },
    handleSwitchLogin() {
      this.$emit("handleSwitchLogin", 2);
    }
  }
};
</script>

<style scoped lang="less">
.loginByQRCode {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 680px;
  height: 630px;
  background: #ffffff;
  box-shadow: 0px 6px 50px 12px rgba(0, 0, 0, 0.05);
  border-radius: 20px;
  // filter: blur(50px);

  .switchBtn {
    position: absolute;
    top: 0;
    right: 0;
    width: 110px;
    height: 110px;
  }

  .luojigouHead {
    margin-top: 34px;
    width: 132px;
    height: 132px;
  }

  .title {
    margin: -6px 0 10px;
    font-size: 26px;
    font-weight: 600;
    color: #333333;
  }

  .mark,
  .tips {
    font-weight: normal;
    font-size: 20px;
    color: #666666;
  }

  .container {
    margin: 27px 0;
    position: relative;

    .QRCode {
      width: 280px;
      height: 280px;

      img {
        width: 280px;
        height: 280px;
        background-color: #fff;
        padding: 6px;
        box-sizing: border-box;
      }
    }

    &-mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,.6);
      cursor: pointer;

      span {
        color: #fff;
        font-size: 24px;
        font-weight: 600;
      }

      span + span {
        margin-top: 10px;
      }
    }
  }
}
</style>
